<template>
  <div
    class="no-child-catchup-banner rounded-10 d-flex justify-content-between align-items-center nowrap"
  >
    <!-- LEFT SECTION -->
    <div class="left-section">
      <div class="welcome-title font-weight-bold color_white">
        Welcome to Catchup!
      </div>

      <!-- WELCOME TEXT -->
      <div class="welcome-text color_grey_light">
        With over 40,000 Gamified practice and video lessons across all topics.
        Start by adding your child. Gradely CatchUp! provides all your child
        needs to measure up. Add a child to get started.
      </div>
      <!-- WELCOME TEXT -->

      <!-- WELCOME BTN -->
      <div class="welcome-btn">
        <button @click="addNewChild" class="btn btn-accent font-weight-bold">
          Add a Child
        </button>
      </div>
      <!-- WELCOME BTN -->
    </div>

    <!-- RIGHT SECTION -->
    <div class="right-section">
      <img v-lazy="localImg('EmptyCatchup.png')" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "CatchupBannerNoChild",

  methods: {
    addNewChild() {
      this.$router.push("/parent/onboarding/new-child");
    },
  },
};
</script>

<style lang="scss">
.no-child-catchup-banner {
  margin-top: 20px;
  margin-bottom: 40px;
  padding: 55px 50px;
  background: rgba(#000, 0.5);

  @include breakpoint_max(xl) {
    padding: 45px;
  }

  @include breakpoint_max(lg) {
    padding: 45px 35px;
  }

  .left-section {
    .welcome-title {
      font-size: 32px;
      line-height: 44px;
      margin-bottom: 20px;

      @include breakpoint_max(xl) {
        font-size: 26px;
        font-weight: 500;
      }

      @include breakpoint_max(sm) {
        font-size: 18px;
        font-weight: 500;
      }
    }
    .welcome-text {
      font-size: 14.5px;
      line-height: 165%;
      margin-bottom: 30px;
      width: 420px;

      @include breakpoint_max(lg) {
        font-size: 13.25px;
        width: 320px;
      }

      @include breakpoint_max(md) {
        width: 100%;
      }

      @include breakpoint_max(sm) {
        font-size: 13px;
      }
    }

    .welcome-btn {
      .btn {
        font-weight: bold;
        font-size: 10px;
      }

      @include breakpoint_max(lg) {
        margin-bottom: 30px;
      }

      @include breakpoint_max(md) {
        margin-bottom: 5px;
      }
    }
  }

  .right-section {
    img {
      width: 510px;
      height: 320px;

      @include breakpoint_max(xl) {
        width: 420px;
        height: 240px;
      }

      @include breakpoint_max(lg) {
        width: 320px;
        height: 200px;
      }

      @include breakpoint_max(md) {
        display: none;
      }
    }
  }
}
</style>
